/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Kept_Not_AddedInputs */

const en_us2_draft_kept_not_added = /** @type {(inputs: Draft_Kept_Not_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You didn't add it`)
};

const pt_br2_draft_kept_not_added = /** @type {(inputs: Draft_Kept_Not_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não adicionou`)
};

const es_419_draft_kept_not_added = /** @type {(inputs: Draft_Kept_Not_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No lo agregaste`)
};

const pt_pt2_draft_kept_not_added = /** @type {(inputs: Draft_Kept_Not_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não adicionaste`)
};

const fr_fr2_draft_kept_not_added = /** @type {(inputs: Draft_Kept_Not_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu ne l'as pas ajouté`)
};

const de_de2_draft_kept_not_added = /** @type {(inputs: Draft_Kept_Not_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast sie nicht hinzugefügt`)
};

const it_it2_draft_kept_not_added = /** @type {(inputs: Draft_Kept_Not_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non l'hai aggiunto`)
};

/**
* | output |
* | --- |
* | "You didn't add it" |
*
* @param {Draft_Kept_Not_AddedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_kept_not_added = /** @type {((inputs?: Draft_Kept_Not_AddedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Kept_Not_AddedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_kept_not_added(inputs)
	if (locale === "es-419") return es_419_draft_kept_not_added(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_kept_not_added(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_kept_not_added(inputs)
	if (locale === "de-DE") return de_de2_draft_kept_not_added(inputs)
	if (locale === "it-IT") return it_it2_draft_kept_not_added(inputs)
	return en_us2_draft_kept_not_added(inputs)
});
export { draft_kept_not_added as "draft.kept_not_added" }